/**
 * Inline SVG helper.
 * The prototype fetched the SVGs at runtime so it could rewrite
 * `class="st0"` into `fill="currentColor"`; in Vite we import the
 * raw markup at build time and apply the same transform once.
 */
export function prepareSvg(raw: string): string {
  return raw
    .replace(/<\?xml[^?]*\?>/g, '')
    .replace(/class="st0"/g, 'fill="currentColor"')
    .replace(/style="[^"]*"/g, '')
    // Strip width/height so the wrapper controls sizing.
    .replace(/<svg([^>]*?)\swidth="[^"]*"/, '<svg$1')
    .replace(/<svg([^>]*?)\sheight="[^"]*"/, '<svg$1');
}
